// The kitchen alert tone: an insistent two-note repeat while a new order waits to be accepted.
export function playKitchenTone() {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();

    if (ctx.state === 'suspended' && ctx.resume) {
      ctx.resume().catch(() => {});
    }

    const now = ctx.currentTime;
    const playNote = (freq, start, duration, peakGain = 0.2) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'square';
      osc.frequency.setValueAtTime(freq, now + start);
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(peakGain, now + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + duration);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + start);
      osc.stop(now + start + duration + 0.05);
    };

    // A5 → E5, twice — urgent but not harsh, cuts through kitchen noise
    playNote(880.0, 0.00, 0.18, 0.12);
    playNote(659.25, 0.20, 0.30, 0.14);
    playNote(880.0, 0.60, 0.18, 0.12);
    playNote(659.25, 0.80, 0.35, 0.14);

    setTimeout(() => ctx.close && ctx.close().catch(() => {}), 1600);
  } catch (_) {
    // audio blocked or unsupported — silently ignore
  }
}
